export const UNSTOPPABLE_TLDS = [
  '888',
  'agent',
  'ai4',
  'altimist',
  'amped',
  'anime',
  'anyone',
  'arculus',
  'ask',
  'ath',
  'aura',
  'austin',
  'awaken',
  'bald',
  'basenji',
  'bay',
  'bch',
  'binanceus',
  'bitcoin',
  'bitget',
  'bitscrunch',
  'blockchain',
  'bobi',
  'boomer',
  'brave',
  'bunni',
  'calicoin',
  'carbon',
  'cashme',
  'caw',
  'cgai',
  'chip',
  'chomp',
  'clay',
  'collect',
  'crypto',
  'dao',
  'dejay',
  'demos',
  'depin',
  'derad',
  'dfz',
  'digibyte',
  'digitalfuture',
  'doga',
  'donut',
  'dream',
  'dsci',
  'emir',
  'enigma',
  'ethermail',
  'go',
  'goblin',
  'gotchi',
  'grow',
  'hegecoin',
  'her',
  'hi',
  'horizen',
  'housecoin',
  'hub',
  'imtoken',
  'kingdom',
  'klever',
  'kresus',
  'kryptic',
  'learn',
  'lfg',
  'ltc',
  'lunar',
  'manga',
  'marketer',
  'mery',
  'metropolis',
  'miku',
  'ministry',
  'mobix',
  'moon',
  'mooncat',
  'mumu',
  'mycircle',
  'nft',
  'nibi',
  'npc',
  'og',
  'ohm',
  'onchain',
  'openx',
  'pack',
  'pastor',
  'pbdx',
  'pendle',
  'pengu',
  'pilot',
  'podcast',
  'pog',
  'pokt',
  'polygon',
  'presearch',
  'privacy',
  'propykeys',
  'pudgy',
  'pundi',
  'quantum',
  'rad',
  'raiin',
  'retardio',
  'secret',
  'smobler',
  'sonic',
  'south',
  'spend',
  'stepn',
  'super',
  'supernova',
  'swamp',
  'tball',
  'tea',
  'tigershark',
  'tribe',
  'troll',
  'twin',
  'u',
  'ubu',
  'undeads',
  'unstoppable',
  'verge',
  'wallet',
  'web3',
  'wif',
  'wifi',
  'witg',
  'wrkx',
  'x',
  'xec',
  'xmr',
  'xyo',
  'yellow',
  'zano',
  'zil',
];
